module.exports = __webpack_public_path__ + "static/media/logo.e73cb8d3.svg";